export const handleScrollToBottom = (e, callback: () => void) => {
  const element = e.target;
  const threshold = 0;
  if (
    (window.screen.width < 768 && element.scrollWidth - element.scrollLeft - threshold <= element.clientWidth) ||
    (window.screen.width >= 768 && element.scrollHeight - element.scrollTop - threshold <= element.clientHeight)
  ) {
    callback();
  }
};
